<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import type { ButtonVariants } from "@/shared/ui/button"
import { AlertDialogAction } from "reka-ui"
import { Button } from "@/shared/ui/button"

/**
 * Кнопка підтвердження діалогу. Reka-семантику (auto-close через onOpenChange,
 * focus-учасник) бере reka `AlertDialogAction`; вигляд + loading-контракт DS —
 * композований `Button` (as-child). Loading живе ТІЛЬКИ в `Button` (ADR-0015 D1),
 * обгортка її не дублює. `as`/`asChild` назовні не виставляємо — корінь фіксовано
 * на <button> (внутрішній as-child зайнятий композицією Button).
 */
const props = withDefaults(
  defineProps<{
    loading?: boolean
    variant?: ButtonVariants["variant"]
    size?: ButtonVariants["size"]
    class?: HTMLAttributes["class"]
  }>(),
  { loading: false, variant: "default" },
)
</script>

<template>
  <!-- as-child → reka мерджить onClick=onOpenChange(false)+type у Button (рівно один
       child). Button — звичайний child (НЕ asChild), тож спінер рендериться штатно. -->
  <AlertDialogAction as-child>
    <Button
      data-slot="alert-dialog-action"
      :variant="props.variant"
      :size="props.size"
      :loading="props.loading"
      :class="props.class"
    >
      <slot />
    </Button>
  </AlertDialogAction>
</template>
